
import {mapGetters} from 'vuex'

import {
  FORM_FIELDS_VALIDATION_STATE,
  MUTATE_SET_FIELDS_VALIDATION_STATE
} from '../store/modules/active-form-section-validations'

export default {
  computed: {
    ...mapGetters({
      getLang: FORM_FIELDS_VALIDATION_STATE
    })
  },
  methods: {
    highlightIfError(key){
     return this.getLang.includes(key)? {border: '2px solid #da8787'} : {}
    },
    setVueValidations(payload){
      this.$store.commit(MUTATE_SET_FIELDS_VALIDATION_STATE, payload)
    }
  }
}
